import { z } from 'zod'

// shared coercer for boolean query-string params. accepts a real boolean OR
// the literal strings "true"/"false" and applies the supplied default when
// the field is omitted. the four cash-flow toggles + any future query-string
// boolean should reach for this factory rather than re-spelling the union.
export const coercedBooleanWithDefault = (defaultValue: boolean) =>
  z
    .union([z.boolean(), z.enum(['true', 'false']).transform((v) => v === 'true')])
    .optional()
    .default(defaultValue)
